import FeedMappingList from './FeedMappingList';

export default FeedMappingList;
